export default (theme) => ({
  flexBox: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      marginBottom: 20
    }
  },
  inlineFlex: {
    display: 'inline-flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  column: {
    flexDirection: 'column',
  },
  reverseColumn: {
    flexDirection: 'column-reverse',
  },
  marginBottom: {
    marginBottom: 8,
  },
  rowWrapper: {
    marginBottom: 8,
    width: '100%',
    '&:last-child': {
      marginBottom: 0,
    },
  },
  // Rows share two equal columns, so field edges line up; a lone field sits on the side its row aligns to.
  fields: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 8,
    width: 288,
    maxWidth: '100%',
    '& > *': {
      width: 'calc(50% - 4px)',
    },
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start',
    },
  },
  // The width of the delete button column, so the Start time fields line up with the hour rows.
  gutter: {
    marginRight: 39,
    maxWidth: 'calc(100% - 39px)',
  },
  regularFontWeight: {
    fontWeight: 300,
  },
  paddingBottom: {
    paddingBottom: 8,
  },
  disabledButton: {
    cursor: 'not-allowed',
  },
  deleteButton: {
    padding: 0,
    marginLeft: 15,
    color: theme.palette.textColor.red,
    width: 24,
    '&:hover': {
      color: theme.palette.textColor.red,
      background: theme.palette.background.default,
    },
    '&:focus': {
      color: theme.palette.textColor.red,
      background: theme.palette.background.default,
    },
  },
  individualDeleteButton:{
    [theme.breakpoints.down('sm')]: {
      marginBottom: '-25px',
    }
  },
  travelTimeBlock: {
    margin: '10px 0',
    display: 'flex',
    justifyContent: 'space-between',
  },
  travelTimeWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  travelInputsWrapper: {
    width: '100%',
  },
  hidden: {
    visibility: 'hidden',
  },
  addButton: {
    padding: 0,
    color: theme.palette.textColor.primary,
    '&:hover': {
      color: theme.palette.textColor.primary,
      background: `${theme.palette.background.default} !important`,
    },
    '&:focus': {
      color: theme.palette.textColor.primary,
      background: `${theme.palette.background.default} !important`,
    },
  },
  textCenter: {
    textAlign: 'center',
  },
  startTimeWrapper: {
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    },
  },
  mobileHidden: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
});
